import React, { ElementType } from 'react';
import { useFormContext } from 'react-hook-form';
import { Tab, TabList, TabPanel, Tabs } from '../../../../../CommonComponents/OPL/Tab';
import { SyncOptions } from '../../../../../Profile/Accounts/Features/AccountPreferences/components/AccountForm/components/SyncOptions/SyncOptions';
import {
  FormFields,
  FormProps,
  getShowAssetAllocationTab,
  INSURANCE_TYPES_WITH_BENEFICIARIES_TAB,
} from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { AssetAllocation } from '../AssetAllocation/AssetAllocation';
import { Beneficiaries } from '../Beneficiaries/Beneficiaries';

interface Tab {
  Component: ElementType;
  name: string;
}

interface Props extends FormProps {
  tabs: Tab[];
}

export const TabsContent = ({
  tabs,
  data,
  insurance,
  accountPortfolioData,
  isEstatePlanningWorkflow,
  setAlert,
}: Props) => {
  const formBag = useFormContext<FormFields>();

  const [
    isLinked,
    isIntegrated,
    LifeInsurancePolicyType,
    LifeInsurancePermanentType,
  ] = formBag.watch([
    'IsLinked',
    'IsIntegrated',
    'LifeInsurancePolicyType',
    'LifeInsurancePermanentType',
  ]);

  const enhancedTabs = [...tabs];

  const showAssetAllocationTab = getShowAssetAllocationTab({
    insurance: { ...insurance, LifeInsurancePolicyType, LifeInsurancePermanentType },
  });

  if (showAssetAllocationTab) {
    enhancedTabs.push({
      name: 'Asset Allocation',
      Component: AssetAllocation,
    });
  }

  if (
    typeof insurance.InsuranceType === 'number' &&
    INSURANCE_TYPES_WITH_BENEFICIARIES_TAB.includes(insurance.InsuranceType)
  ) {
    enhancedTabs.push({
      name: 'Beneficiaries',
      Component: Beneficiaries,
    });
  }

  if (isLinked || isIntegrated) {
    enhancedTabs.push({
      name: 'Sync Options',
      Component: SyncOptions,
    });
  }

  return (
    <Tabs>
      <TabList>
        {enhancedTabs.map(({ name }) => (
          <Tab key={name}>{name}</Tab>
        ))}
      </TabList>

      {enhancedTabs.map(({ Component, name }) => (
        <TabPanel key={name}>
          <Component
            data={data}
            accountPortfolioData={accountPortfolioData}
            isEstatePlanningWorkflow={isEstatePlanningWorkflow}
            setAlert={setAlert}
          />
        </TabPanel>
      ))}
    </Tabs>
  );
};
